import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import zagreb from "../images/zagreb.jpg";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { APIvar } from '../services/variables';

const useColor = APIvar.colorUse;

function LandingPage() {
  return (
    <Box sx={{height:"92%"}}>
      <Container   fixed sx={{
      
        bgcolor: '#cfe8fc', height:'7%', minWidth:'100%', padding:"0", display: "flex", alignItems:"center", justifyContent:"space-between"}}>

        <Typography>
          --------/--------
        </Typography>
        
        <Typography>
          -------------
        </Typography>
        
      </Container>
      <Box 
        className="lading-page"
        style = {{
          
            backgroundImage: `url(${zagreb})`,
            backgroundColor: "#cccccc",
            height: '93%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
          
        }}
      
      >
       <Grid container sx={{height:"100%"}}>
          <Grid xs={7} sx={{ display: "flex", alignItems:"center", justifyContent:"center"}}>
              <Typography variant="h2" gutterBottom sx={{color: useColor, padding: "0 3em 0 0"}}>
                Val
              </Typography>
          </Grid>
          <Grid xs={5}  sx={{ display: "flex", alignItems:"center", justifyContent:"center"}}>
              <Typography variant="h3" gutterBottom sx={{color: "black"}}>
               -------------
              </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default LandingPage;
